import { useEffect, useState } from 'react';
import { Outlet, useNavigate, useNavigation } from 'react-router-dom';
import { ItemRoutesInterface, RoutesTypesInterface } from 'types/interfaces';
import Footer from './Footer';
import Header from './Header';
import './styles.scss';

interface MainLayoutProps {
  routes: RoutesTypesInterface;
}
const MainLayout = ({ routes }: MainLayoutProps) => {
  const d = useNavigate();

  const [item, setItem] = useState<ItemRoutesInterface>({} as ItemRoutesInterface);

  const getItem = () => {
    const locationPath = document.location.pathname;

    const it = routes.items.find((obj) => obj.path === locationPath);
    if (it) {
      setItem(it);
    }
  };
  useEffect(() => {
    getItem();
  }, [document.location.pathname, d]);
  return (
    // eslint-disable-next-line no-restricted-globals
    <div className="main-layout-container">
      {/* <Header colorTheme={item.colorTheme} /> */}
      <Outlet />
      <div style={{ height: '163px' }} />
      {/* <Footer colorTheme={item.colorTheme}  /> */}
    </div>
  );
};

export default MainLayout;
